import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import type { TeamSummary } from '@gg/shared';
import { teamProgress } from '@gg/shared';
import { Card } from '@/components/ui';
import { localName, membersLabel } from '@/lib/formats';
import { Roster } from './Roster';

/**
 * Team section of the profile (screen 06): the roster and, for the captain, the link to
 * manage the team (resend, replace, invite the seats left).
 */
export function TeamCard({ team }: { team: TeamSummary }) {
  const { t } = useTranslation();
  const progress = teamProgress(
    { teamSizeMin: team.sizeMin, teamSizeMax: team.sizeMax },
    team.members,
  );
  return (
    <Card aria-labelledby={`team-${team.id}`}>
      <div className="flex items-baseline justify-between gap-3">
        <h2 id={`team-${team.id}`} className="m-0 font-display text-section font-bold">
          {t('teams.title', { name: team.name })}
        </h2>
        {team.isCaptain && team.status !== 'cancelled' && (
          <Link to={`/me/teams/${team.id}`} className="shrink-0 text-sm font-semibold no-underline">
            {t('teams.manage')}
          </Link>
        )}
      </div>
      <p className="m-0 text-helper text-ink-muted">
        {team.status === 'cancelled'
          ? t('teams.cancelled')
          : `${localName(team.formatName, team.formatNameEn)} · ${membersLabel(t, progress.joined, team.sizeMax, team.sizeMin)}`}
      </p>
      <Roster team={team} />
    </Card>
  );
}
